(() => {
  const SELECTOR = '[data-calinfi-news-from-fire]';
  const controllers = new WeakMap();

  const initSection = (section) => {
    if (!section || section.dataset.newsFromFireInitialized === 'true') return;

    const track = section.querySelector('[data-news-track]');
    const slides = Array.from(section.querySelectorAll('[data-news-slide]'));
    const prev = section.querySelector('[data-news-prev]');
    const next = section.querySelector('[data-news-next]');

    if (!track || slides.length === 0) return;

    section.dataset.newsFromFireInitialized = 'true';

    const controller = new AbortController();
    const { signal } = controller;
    let activeIndex = 0;
    let currentPosition = 0;
    controllers.set(section, controller);

    const getStep = () => {
      const firstSlide = slides[0];
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0);

      return firstSlide.getBoundingClientRect().width + gap;
    };

    const getOffset = () => {
      const cardWidth = slides[0].getBoundingClientRect().width;
      const viewportWidth = section.getBoundingClientRect().width;

      return Math.max((viewportWidth - cardWidth) / 2, 16);
    };

    const getStablePosition = () => activeIndex;

    const updateState = () => {
      section.dataset.newsActiveIndex = String(activeIndex);

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;

        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    };

    const moveToPosition = (position, shouldAnimate = true) => {
      currentPosition = position;

      if (!shouldAnimate) {
        track.style.transition = 'none';
      }

      track.style.transform = `translate3d(${getOffset() - getStep() * currentPosition}px, 0, 0)`;
      updateState();

      if (!shouldAnimate) {
        window.requestAnimationFrame(() => {
          track.style.transition = '';
        });
      }
    };

    const setActive = (index) => {
      const nextIndex = (index + slides.length) % slides.length;

      activeIndex = nextIndex;
      moveToPosition(nextIndex);
    };

    prev?.addEventListener('click', () => {
      setActive(activeIndex - 1);
    }, { signal });

    next?.addEventListener('click', () => {
      setActive(activeIndex + 1);
    }, { signal });

    window.addEventListener('resize', () => {
      moveToPosition(getStablePosition(), false);
    }, { signal });

    moveToPosition(getStablePosition(), false);
  };

  document.querySelectorAll(SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches?.(SELECTOR) ? event.target : event.target.querySelector?.(SELECTOR);

    initSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.matches?.(SELECTOR) ? event.target : event.target.querySelector?.(SELECTOR);
    const controller = controllers.get(section);

    controller?.abort();
    controllers.delete(section);

    if (section) delete section.dataset.newsFromFireInitialized;
  });
})();
